<template>
  <div class="table-search">
    <div class="search-holder">
      <InputText
        class="bg-dark iconed"
        @keyup.native="searchTable"
        v-model="searchTerm"
        :value="get_search_term"
        placeholder="Search..." />
    </div>
    <div
      v-if="Object.keys(get_active_filter).length !== 0"
      class="filters-holder m-l-20">
      <Btn
        class="light"
        :icon="{
          name: 'edit',
          size: '16',
        }"
        :btnText="$t('edit')"
        @btnClick="editFilters" />
      <Btn
        class="light m-l-20"
        :icon="{
          name: 'remove',
          size: '24',
        }"
        :btnText="$t('Remove all')"
        @btnClick="removeFilters" />
      <!-- FILTERS -->
      <template v-for="(item, key, index) in get_active_filter">
        <div
          :key="`standard-filter-${index}`"
          class="button light m-l-20 tooltip-holder" @click="removeFilterParameter(key)"
          style="border-radius: 5px 0  0 5px"
        >
        <Icon
          class="btn-icon"
          name="remove"
          size="24" />
          {{ $t(`${key}`) }}
          <span class="d-inline-block info-tooltip" v-if="typeof item.value == 'array' || typeof item.value == 'object'" style="color: gray;position: relative;top: -5px;">
            <Icon
                  v-tooltip="{ html: 'tooltipRef' + index}"
                  name="info"
                  style="position: relative;top: 5px;left: 5px;display: inline;"
                  size="18" />
            <div class="info-tooltip-window" :id="'tooltipRef' + index" v-html="formatFilterDataArray(item.value, key)"></div>
          </span>
             <span v-else  style="color: gray;">: {{ dateFormat(item.value, key) }}</span>
        </div>
      </template><!-- #FILTERS -->
    </div>
    <div
      v-if="Object.keys(get_active_filter).length === 0"
      class="filters-holder m-l-20">
      <Btn
        class="light"
        key="filterTool"
        :icon="{
          name: 'filterTool',
          size: '16',
        }"
        :btnText="$t('Filter')"
        @btnClick="customFilter" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import _ from 'lodash';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import moment from 'moment';
import Dropdown from "@/components/global/dropdown/index.vue";
import countryList from '@/data/country.js';
import financeTypes from '@/data/financeTypes';

export default {
  name: 'TableSearch',
  components: {
    Dropdown,
    InputText, Btn,
  },
  props: {
    filterOptions: {
      type: Object,
      required: true,
    },
    tableActions: String,
  },
  data() {
    return {
      tableData: [],
      searchTerm: '',
    };
  },
  computed: {
    ...mapGetters([
      'get_sidebar_fields',
      'get_active_filter',
      'get_active_filter_name',
      'get_search_term',
      'get_sidebar_table_name',
      'get_sidebar_table_api',
      'get_company_available_shipping_agents_select',
      'get_allowed_subaccounts_select_options'
    ]),
  },
  mounted() {
    if(this.$route.query.hasOwnProperty('searchTerm')) {
      this.searchTerm = this.$route.query.searchTerm;
    }
  },
  methods: {
    formatFilterDataArray(value, key) {
      let html = '';
      if (['receiver_country_id', 'sender_country_id', 'sender_country', 'receiver_country'].includes(key)) {
        value.forEach(countryId => {
          const country = countryList.find(item => item.id == countryId || item.alpha2 == countryId)
          html += '<p>' + country.name + '</p>'
        })
      }
      if (['shipping_agents'].includes(key)) {
        value.forEach(agentId => {
          const agent = this.get_company_available_shipping_agents_select.find(item => item.value == agentId)
          html += '<p>' + agent.text + '</p>'
        })
      }
      if (['invoiced_differences', 'agreement_differences'].includes(key)) {
        value.forEach(financeType => {
          const type = financeTypes.find(item => item.value === financeType)
          html += '<p>' + type.text + '</p>'
        })
      }
      if (['subaccounts'].includes(key)) {
        value.forEach(subaccountId => {
          const subAccount = this.get_allowed_subaccounts_select_options.find(item => item.value == subaccountId)
          html += '<p>' + subAccount.text + '</p>'
        })
      }
      return html
    },
    dateFormat(value, key) {
      let text;
      if(this.get_sidebar_fields[key].type === 'select'){
        this.get_sidebar_fields[key].options.forEach(element => {
          if (element.value === value){
              text = element.text;
           }})
           return text;
         } else if (key === 'ship_date'){
        return moment(value).format('DD/MM/YYYY');
      }else{
        return value;
      }
    },
    apiTableSearchRequest() {
      this.$emit('resetTable')
      this.$store.dispatch(`TABLE_SEARCH`, {
        pageApiURL: this.get_sidebar_table_api,
        filter: this.get_active_filter,
        searchTerm: this.get_search_term,
      }).then((res) => {
        this.$store.dispatch(`CLEAR_${this.tableActions}`);
        this.$store.dispatch(`STORE_${this.tableActions}`, res);
        this.$emit('stopLoading')
      });
    },
    searchTable:  _.debounce(function(event) {
      // if(this.searchTerm.length < 3) return;
      this.$store.dispatch('STORE_SEARCH', this.searchTerm).then(() => {
        this.constructURL();
        this.apiTableSearchRequest();
      })
    }, 200),
    removeFilterParameter(key) {
      if(Object.keys(this.get_active_filter).length == 1){
        this.removeFilters();
      } else {
        this.$store.dispatch('SET_IS_CUSTOM_FILTER_NAME', false);
        this.$store.dispatch('REMOVE_EXISTING_FILTER_PARAM', key).then(() => {
          this.constructURL();
          this.apiTableSearchRequest();
        });
      }
    },
    removeFilters() {
      this.$store.dispatch('SET_IS_CUSTOM_FILTER_NAME', false);
      this.$store.dispatch('CLEAR_ACTIVE_FILTER');
      this.constructURL();
      this.apiTableSearchRequest();
    },
    editFilters() {
      this.$store.dispatch('SET_IS_NEW_FILTER', false);
      this.$store.dispatch('OPEN_SIDEBAR');
    },
    customFilter() {
      this.$store.dispatch('SET_IS_CUSTOM_FILTER_NAME', false);
      this.$store.dispatch('SET_IS_NEW_FILTER', true);
      this.$store.dispatch('OPEN_SIDEBAR');
    },
    constructURL() {
      this.$router.push({
        path: this.$route.path,
        query: {
          search: JSON.stringify(this.get_active_filter),
          searchTerm: this.get_search_term,
        },
      });
    },
    filterForTypeSelect() {
      if(this.get_sidebar_fields[key].type === 'select'){
            /* this.get_sidebar_fields[key].options.forEach(element => {
              if (element.value === this.formFields[key].value){
                dataObject[key] = {value:element.text} */
                /* dataObject[key] = this.formFields[key]; */
      }
    }
  },
}
</script>
<style>
.h-tooltip {
  max-height: 400px !important;
  overflow-y: auto !important;
}
</style>
